import googleIcon from '../icons/google.png';
import metaIcon from '../icons/meta.png';
import tiktokIcon from '../icons/tiktok.png';

interface PromoteIconProps {
  type: string;
}

const getIcon = (type) => {
  switch (type) {
    case 'google':
      return googleIcon;
    case 'meta':
      return metaIcon;
    case 'tiktok':
      return tiktokIcon;
    default:
      return googleIcon;
  }
};

function PromoteIcon({ type }: Readonly<PromoteIconProps>) {
  return (
    <div className="icon-container-promote">
      <img alt="promote-icon" src={getIcon(type)} />
    </div>
  );
}

export default PromoteIcon;
